import { GET_UICART_QUERY } from './uiCart.graphql.js';

// https://www.apollographql.com/docs/react/data/local-state/#initializing-the-cache
export const defaultState = {
  uiCart: {
    __typename: 'UiCart',
    isOpen: false,
  },
};

// https://www.apollographql.com/docs/react/data/local-state/#client-side-schema
export const typeDefs = `
  type UiCart {
    isOpen: Boolean!
  }

  extend type Query {
    uiCart: UiCart!
  }

  extend type Mutation {
    updateUiCart(isOpen: Boolean!): UiCart
  }`;

// By using the typename, and by making sure
// the mutation returns an UiCart Object type,
// we get an automatic cache update.
// https://www.apollographql.com/docs/react/caching/cache-configuration/#custom-identifiers
export const customCacheIdentifiers = {
  UiCart: object => object.__typename,
};

// https://www.apollographql.com/docs/react/data/local-state/#local-resolvers
export const resolvers = {
  Mutation: {
    updateUiCart: (_, args, { cache }) => {
      const { uiCart } = cache.readQuery({ query: GET_UICART_QUERY });
      const newUiCart = {
        ...uiCart,
        ...args,
      };

      cache.writeData({
        data: {
          uiCart: newUiCart,
        },
      });

      return newUiCart;
    },
  },
};
